import Crud from '../components/CityDestination/Crud'
import Entity from '../components/CityDestination/Add'

let routes = {
    path: '/cityDestinations',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/cityDestinations/add',
            name: 'Nova Cidade',
            component: Entity
        },
        {
            path: '/cityDestinations/edit/:id?',
            name: 'Editar Cidade',
            component: Entity
        },
        {
            path: '/cityDestinations',
            name: 'Cidades',
            component: Crud
        },
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/cityDestination.js